// src/screens/KlarnaConfirmationScreen.js
export default function KlarnaConfirmationScreen() {
    return <div className="container py-5">Pagamento confirmado com Klarna</div>;
}
